import script from "./AdminNews.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNews.vue?vue&type=script&setup=true&lang=js"

import "./AdminNews.vue?vue&type=style&index=0&id=4804d014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4804d014"]])

export default __exports__